module.exports = __webpack_public_path__ + "posture/static/img/cover-bg.6cc1e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/cover-bg.png
// module id = kWoR
// module chunks = 1